<template>
  <pdp-section-gallery>
    <template v-if="mediaGalleryHorizontalScroll?.enabled" #progressbar>
      <div />
    </template>
  </pdp-section-gallery>
</template>

<script lang="ts" setup>
import PdpSectionGallery from '#brand/components/pdp/section/Gallery.vue'

const mediaGalleryHorizontalScroll = useOptimizelyFlag('media_gallery_horizontal_scroll')
</script>
